import {Paper, Box, Typography, Button, Alert, TextField} from '@mui/material'
import {useLocation, useNavigate} from 'react-router-dom'
import {useFormik} from 'formik'
import * as yup from 'yup'
import CircularProgress from '@mui/material/CircularProgress'
import * as authAPI from '../AuthApi'
import {useFormikTextFieldHelpers} from '../../../components/hooks/useFormikTextFieldHelpers'
import {useAlerts} from '../../common/components/alerts/useAlerts'

const ForgotPasswordPage = () => {
  const navigate = useNavigate()
  const {pushError} = useAlerts()
  const {key} = useLocation()

  const formik = useFormik({
    initialValues,
    validationSchema,
    validateOnMount: true,
    onSubmit: async (values, {setStatus}) => {
      setStatus('')
      try {
        await authAPI.forgotPassword(values.email)
        setStatus('An email has been sent the your email address.')
      } catch (e) {
        pushError(e)
      }
    },
  })
  const formikTextInputHelper = useFormikTextFieldHelpers(formik)

  return (
    <Paper
      sx={{
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        overflow: 'hidden',
        width: '80vw',
        maxWidth: '30rem',
      }}
    >
      <Box
        sx={(theme) => ({
          backgroundColor: theme.palette.primary.main,
          color: theme.palette.primary.contrastText,
          textAlign: 'center',
          textTransform: 'uppercase',
          p: theme.spacing(2),
        })}
      >
        <Typography
          component='h1'
          variant='h6'
          sx={{
            letterSpacing: '0.1em',
            fontWeight: '700',
          }}
        >
          Forgot Password?
        </Typography>
      </Box>
      <Box
        component='form'
        sx={(theme) => ({
          display: 'flex',
          flexDirection: 'column',
          padding: theme.spacing(5),
          [theme.breakpoints.down('md')]: {
            padding: theme.spacing(3),
          },
          [theme.breakpoints.down('sm')]: {
            padding: theme.spacing(2),
          },
        })}
        autoComplete='off'
        onSubmit={formik.handleSubmit}
      >
        {formik.status && (
          <Alert severity='success' sx={(theme) => ({mb: theme.spacing(3)})}>
            {formik.status}
          </Alert>
        )}
        <TextField
          InputLabelProps={{
            shrink: true,
          }}
          autoFocus
          id='field-email'
          label='Email'
          placeholder='Enter Email'
          fullWidth
          type='email'
          {...formikTextInputHelper.getFieldProps('email')}
        />
        <Box sx={{display: 'flex', justifyContent: 'flex-end'}}>
          <Button
            id='button-back'
            type='button'
            variant='contained'
            color='primary'
            onClick={() => {
              key === 'default' ? navigate('/auth/login', {replace: true}) : navigate(-1)
            }}
            sx={(theme) => ({mr: theme.spacing(1)})}
          >
            Back
          </Button>
          <Button
            id='button-submit'
            disabled={formik.isSubmitting || !formik.isValid}
            type='submit'
            variant='contained'
            color='primary'
            sx={{
              position: 'relative',
            }}
          >
            Submit
            {formik.isSubmitting && (
              <CircularProgress
                size={24}
                sx={{
                  position: 'absolute',
                  top: '50%',
                  left: '50%',
                  marginTop: '-12px',
                  marginLeft: '-12px',
                }}
              />
            )}
          </Button>
        </Box>
      </Box>
    </Paper>
  )
}

const initialValues = {
  email: '',
}

const validationSchema = yup.object().shape({
  email: yup.string().email().required('Please enter a valid email.'),
})

export default ForgotPasswordPage
